<app-geolocation-loading-overlay></app-geolocation-loading-overlay>
<div [class.show]="!isLoading" [class.hide]="isLoading">
  <router-outlet></router-outlet>
</div>
<div [class.show]="isLoading" [class.hide]="!isLoading">
  <app-loading-page></app-loading-page>
</div>